import { render, staticRenderFns } from "./DayOfWeek.vue?vue&type=template&id=22809494&lang=pug&"
import script from "./DayOfWeek.vue?vue&type=script&lang=js&"
export * from "./DayOfWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports